import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faTimesCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { CardBody, Card, Table } from "reactstrap";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import "./admincontent.css";
import httpService from "../../../services/http.service";
import Select from "react-select";
import { faPlusSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import iconImage from "../../../assets/download.jpg";
import validator from 'validator';
import { CHECK_KEYLOK } from "../../../config";
import Loader from "../../common/loader";
import { Link } from "react-router-dom";
import ChannelStats from "../channelstats";
import WarningMessage from "../../common/warnMsg";
import SuccessMessage from "../../common/successMsg";
import Swal from 'sweetalert2'
import CommonUtils from "../../common/commonUtiles";
import ErrorMessage from "../../common/errorMsg";
import { TimeOverLaping } from "../cloudDashboard/cloudDashboard";
import "../cloudDashboard/propertyDashboard/formModel/addEditChannleForm.css";
import NasPop from "../../rightcolumn/NasSelectModalWindow/nasPop";
import TimePicker from "../../common/TimePicker";
import commonUtiles from "../../common/commonUtiles";

const AdminDashboard = (props) => {
  function isAfterNow(time) {
    return new Date(time).getTime() > new Date().getTime();
  }
  const NasUser = localStorage.getItem('customerId')
  const [propertyClasses, setPropertyClasses] = useState([]);
  const [ruleForProperty, setRuleForProperty] = useState("");
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({});
  const [userClasses, setUserClasses] = useState([]);
  const [toggleUserDetail, settoggleUserDetail] = useState(false);
  const [arrowClasses, setArrowClasses] = useState([]);
  const [channelsClass, setChannelsClass] = useState([]);
  const [IPFormatDataValue, setIPFormatDataValue] = useState([]);
  const [IPFormatV, setIPFormatV] = useState([]);
  const [IPFormatVal, setIPFormatVal] = useState([]);
  const [IPFormatData, setIPFormatData] = useState([]);
  const [onClickDelete, setOnclickDelete] = useState('');
  const [toggleChannelDelete, settoggleChannelDelete] = useState(false);
  const [toggleChannelShow, settoggleChannelShow] = useState(false);
  const [ruleEditRulemodal, settoggleEditRuleModal] = useState(false);
  const [channelRuleExisting, setchannelRuleExisting] = useState("");
  const [channelIdforRule, setchannelIdforRule] = useState("");
  const [channelRuleName, setchannelRuleName] = useState("");
  const [onClickData, setOnclickData] = useState({});
  const [array2, setArray2] = useState([]);
  const [array1, setArray1] = useState([]);
  const [delId, setDelId] = useState('');
  const [save3, setSave3] = useState(false);
  const [save, setSave] = useState(false);
  const [save1, setSave1] = useState(false);
  const [dataStats, setdataStats] = useState({});
  const [onClickRuleData, setOnclickRuleData] = useState({});
  const [defaultVal, setDefaultVal] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [array3, setArray3] = useState([]);
  const [propertyVal, setPropertyVal] = useState([]);
  const [selectedPropertyValues, setSelectedPropertyValues] = useState([]);
  const [propertyeditmodal, setpropertyeditmodal] = useState(false);
  const [ruleEditmodal, setRuleEditmodal] = useState(false);
  const [onClickProperty, setOnclickProperty] = useState({});
  const [selectedRuleValues, setSelectedRuleValues] = useState([]);
  const [rulecount, setRuleCount] = useState(0);
  const [show2, setShow2] = useState(false);
  const [ipAddressPlaceHolder, setIpAddressPlaceHolder] = useState('255.255.255.0')
  const [ipAddressNote, setIpAddressNote] = useState('')
  const [layouts, setLayouts] = useState([]);
  const [onClickAddAndEditMsg, setOnClickAddAndEditMsg] = useState("Add");
  const [ruleSelectedValue, setRuleSelectedValue] = useState([]);
  const [replicateData, setReplicateData] = useState("");
  const [layoutLocalReplicate, setlayoutLocalReplicate] = useState("");
  const [modaleditLayoutPropPass, setmodaleditLayoutPropPass] = useState(false);
  const [replicateUser, setReplicateUser] = useState('')
  const [replicateProperty, setReplicateProperty] = useState('')
  const [hideProperty, setHideProperty] = useState(true)
  const [showPicker, setShowPicker] = useState(false)
  const [files, setFiles] = useState()
  const [selectedFiles, setSelectedFiles] = useState({});

  const getLicensedProperty = async () => {
    let propertyCount = await CommonUtils.getLicensedProp();
    console.log(propertyCount, 1212)
    setHideProperty(propertyCount)
  }

  useEffect(() => {
    if (CHECK_KEYLOK) getLicensedProperty()
    GetAllLayout();
  }, [])


  const toggleRuleEditModal = () =>
    settoggleEditRuleModal((prevState) => !prevState);
  const togglepropertyedit = () =>
    setpropertyeditmodal((prevState) => !prevState);
  const toggleShowChannel = () =>
    settoggleChannelShow((prevState) => !prevState);
  const toggleRuleEdit = () => {
    props.getAllPropertyData();
    setRuleEditmodal((prevState) => !prevState);
  }

  const toggleChannelStat = () =>
    setShow2((prevState) => !prevState);



  useEffect(() => {
    if (
      props.allData &&
      Object.keys(props.allData).length > 0 &&
      props.allData.users.length > 0
    ) {
      let classes = [...propertyClasses];
      if (localStorage.getItem("dashboardPropertyClasses"))
        classes = [
          ...localStorage.getItem("dashboardPropertyClasses").split(","),
        ];
      let userclasses = [...userClasses];
      if (localStorage.getItem("dashboardUserClasses"))
        userclasses = [
          ...localStorage.getItem("dashboardUserClasses").split(","),
        ];
      let arrowclasses = [...arrowClasses];
      if (localStorage.getItem("dashboardArrowClasses"))
        arrowclasses = [
          ...localStorage.getItem("dashboardArrowClasses").split(","),
        ];

      for (let i = 0; i < props.allData.users.length; i++) {
        if (i >= classes.length) {
          classes.push("none");
          userclasses.push("btn-100 btn btn-secondary");
          arrowclasses.push("faPlusCircle");
        }
      }
      setPropertyClasses(classes);
      setUserClasses(userclasses);
      setArrowClasses(arrowclasses);
      localStorage.setItem("dashboardPropertyClasses", classes);
      localStorage.setItem("dashboardUserClasses", userclasses);
      localStorage.setItem("dashboardArrowClasses", arrowclasses);
    }
  }, [props.allData.users]);

  useEffect(() => {
    let userClassesTemp = [...userClasses];
    let arrowClassesTemp = [...arrowClasses];
    let propertyClassesTemp = [...propertyClasses];
    let channelsClassesTemp = [...channelsClass];
    for (let i = 0; i < props.sidebarClassesUser.length; i++) {
      if (props.sidebarClassesUser[i] === "1") {
        arrowClassesTemp[i] = "faMinusCircle";
        userClassesTemp[i] = "btn-100-active btn btn-secondary";
        propertyClassesTemp[i] = "";
      } else {
        arrowClassesTemp[i] = "faPlusCircle";
        userClassesTemp[i] = "btn-100 btn btn-secondary";
        propertyClassesTemp[i] = "none";
      }
    }
    for (let i = 0; i < props.sidebarClassesProperty.length; i++) {
      if (props.sidebarClassesProperty[i] === "1") {
        channelsClassesTemp[i] = "";
      } else {
        channelsClassesTemp[i] = "not-visible";
      }
    }
    setChannelsClass(channelsClassesTemp);
    setUserClasses(userClassesTemp);
    setArrowClasses(arrowClassesTemp);
    setPropertyClasses(propertyClassesTemp);
    localStorage.setItem("dashboardUserClasses", userClassesTemp);
    localStorage.setItem("dashboardArrowClasses", arrowClassesTemp);
    localStorage.setItem("dashboardPropertyClasses", propertyClassesTemp);
    localStorage.setItem("dashboardChannelClasses", channelsClassesTemp);
  }, [
    props.sidebarClassesChannel,
    props.sidebarClassesUser,
    props.sidebarClassesProperty,
  ]);

  useEffect(() => {
    if (props.allData && Object.keys(props.allData).length > 0) {
      let classes = [...channelsClass];
      if (localStorage.getItem("dashboardChannelClasses"))
        classes = [
          ...localStorage.getItem("dashboardChannelClasses").split(","),
        ];
      for (let i = 0; i < props.allData.property.length; i++) {
        if (i >= channelsClass.length) {
          classes.push("not-visible");
        }
      }

      setChannelsClass(classes);
      localStorage.setItem("dashboardChannelClasses", classes);
    }
  }, [props.allData.property]);

  const channelUpdatefun = (e) => {
    showLoader();
    setSave(false);
    settoggleChannelShow(true);
    PropertyArray(e, e.UserId);

    if (e.PropertyType) {
      let selectedKeys = e.PropertyType;
      let arr = [];
      for (let i = 0; i < selectedKeys.length; i++) {
        let obj = {
          value: selectedKeys[i].value,
          label: selectedKeys[i].label,
        };
        arr.push(obj);
      }
      setSelectedPropertyValues(arr);
      setPropertyVal(arr);
    }
    setOnclickData(e);
    hideLoader();
  };

  const ruleUpdatefun = (e, propertyData) => {
    toggleRuleEditModal();
    if (e.PropertyType && e.PropertyType.length > 0) {
      for (let i = 0; i < e.PropertyType.length; i++) {
        if (e.PropertyType[i].PropertyId == propertyData._id) {
          let selectedKeys = e.PropertyType[i].AllChannelRule ? e.PropertyType[i].AllChannelRule : [];
          let arr = [];
          for (let i = 0; i < selectedKeys.length; i++) {
            let obj = {
              value: selectedKeys[i].value,
              label: selectedKeys[i].label,
              id: selectedKeys[i].id,
              // data:selectedKeys[i].data,
            };
            arr.push(obj);
          }
          setRuleSelectedValue(arr)
        }
      }
    }
    setRuleForProperty(propertyData._id);
    ruleArr(e);
    setchannelRuleExisting(e.ChannelRulesId ? e.ChannelRulesId : "");
    setchannelIdforRule(e._id)
    // setchannelRuleName(e.ChannelRulesName);
    for (let i = 0; i < e.PropertyType.length; i++) {
      if (e.PropertyType[i].PropertyId) {
        if (e.PropertyType[i].PropertyId === propertyData._id) {
          setchannelRuleName(e.PropertyType[i].ChannelRulesName);
          setOnclickDelete(e.PropertyType[i].ChannelRulesName);
          break;
        }
      }
    }
    setOnclickData(e);
  };

  let gridOptions = {};
  let onGridReady = {};
  const defaultColDef = {
    sortable: false,
    editable: false,
    flex: 1,
    filter: false,
  };

  const loadSidebar = async (event, RegionID, SystemID, index) => {
    showLoader();
    event.preventDefault();
    let classes = [...channelsClass];
    let y = [...props.propertyButtons];
    for (let i = 0; i < classes.length; i++) {
      if (i !== index) {
        classes[i] = "not-visible";
        y[i] = "fa-plus-circle";
      }
    }
    y[index] =
      classes[index] === "not-visible" ? "fa-minus-circle" : "fa-plus-circle";
    classes[index] = classes[index] === "not-visible" ? "" : "not-visible";
    if (classes[index] === "not-visible") {
      let x = [...props.sidebarClassesProperty];
      for (let i = 0; i < x.length; i++) {
        x[i] = "0";
      }
      props.setsidebarClassesProperty(x);
      localStorage.setItem("propertyClasses", x);
    } else {
      let x = [...props.sidebarClassesProperty];
      for (let i = 0; i < x.length; i++) {
        x[i] = "0";
      }
      x[index] = "1";
      props.setsidebarClassesProperty(x);
      localStorage.setItem("propertyClasses", x);
    }

    setChannelsClass(classes);
    props.setpropertyButtons(y);
    localStorage.setItem("propertyButtons", y);
    localStorage.setItem("dashboardChannelClasses", classes);
    hideLoader();
  };

  const checkProperty = (propArray, id) => {
    return propArray.some((el) => {
      return el.PropertyId === id;
    });
  }

  const handlePropertySelect = (selectedValue) => {
    // check propert if prefield in multiselect
    let checkPreFiledProperty = (selectedValue.length > 0 && propertyVal.length > 0) ?
      propertyVal.filter(element => {
        if (element.value == selectedValue[selectedValue.length - 1].value || element.value == selectedValue[selectedValue.length - 1].PropertyId) {
          return element.value
        }
      }).length : null
    //check how much property have a channel if more than six then user can not add more channels
    let count = selectedValue.length > 0 ?
      props.allData.channels && props.allData.channels.filter((element) => {
        return element.PropertyType.filter(element => {
          if (element.PropertyId == selectedValue[selectedValue.length - 1].PropertyId) {
            return element.PropertyId
          }
        }).length > 0
      }) : null
    if (count != null && count.length >= 6 && (checkPreFiledProperty < 1 || checkPreFiledProperty == null)) {
      WarningMessage(selectedValue[selectedValue.length - 1].label + " Property cannot be added because it already has 6 Channels.")
      return;
    } else {
      setSelectedPropertyValues(selectedValue);
      let arrSelect = [];
      for (let i = 0; i < selectedValue.length; i++) {
        for (let j = 0; j < array2.length; j++) {
          if (selectedValue[i].value == array2[j].value) {
            let obj = {
              PropertyId: `${array2[j].PropertyId}`,
              value: `${array2[j].value}`,
              label: `${array2[j].label}`,
            };
            arrSelect.push(obj);
          }
        }
      }
      let ChannelData = { ...onClickData };
      ChannelData.PropertyType = arrSelect;
      setOnclickData(ChannelData);
    }
  };

  const PropertyArray = (e, userId) => {
    const arr2 = [];
    for (let i = 0; i < props.allData.property.length; i++) {
      let obj = {
        value: `${props.allData.property[i].Name}`,
        label: `${props.allData.property[i].Name}`,
        PropertyId: `${props.allData.property[i]._id}`,
      };
      if (props.allData.property[i].UserId === e.UserId || props.allData.property[i].UserId === e._id) {
        arr2.push(obj);
      }
    }
    setArray2(arr2);
    const arr1 = [];
    for (let i = 0; i < props.allData.layouts.length; i++) {
      let obj = {
        // value: `${props.allData.layouts[i].name} (${window.location.origin}/customer-portal/#/view/${props.allData.layouts[i]._id})`,
        // label: `${props.allData.layouts[i].name} (${window.location.origin}/customer-portal/#/view/${props.allData.layouts[i]._id})`,
        value: `${props.allData.layouts[i].name} (${window.location.origin}/cloud-portal/#/view/${props.allData.layouts[i]._id})`,
        label: `${props.allData.layouts[i].name} (${window.location.origin}/cloud-portal/#/view/${props.allData.layouts[i]._id})`,
      };
      if (props.allData.layouts[i].checked) {
        {
          arr1.push(obj);
        }
      }
    }
    setArray1(arr1);
  }
  const showLoader = () => {
    setLoading(true);
  }
  const hideLoader = () => {
    setLoading(false);

  }

  const ruleArr = (e) => {
    const oprionArrayForRule = [];
    for (let i = 0; i < props.allData.ruleData.length; i++) {
      let obj = {
        value: `${props.allData.ruleData[i]._id}`,
        label: `${props.allData.ruleData[i].ChannelRulesName}`,
        id: `${props.allData.ruleData[i]._id}`,
        data: props.allData.ruleData[i],
      };
      if (
        props.allData.ruleData[i].UserId === e.UserId) {
        {
          oprionArrayForRule.push(obj);
        }
      }
    }
    setArray3(oprionArrayForRule);
  }

  const SaveProperty = async () => {
    showLoader();
    // let UserId = `${localStorage.getItem("UserId")}`;
    let data = {
      userId: onClickProperty.userId,
      user: onClickProperty,
    };
    let data1 = data.user.Name.trim()
      .split("  ")
      .filter((word) => word !== "");
    data.user.ChannelRulesName = data1.join(" ");
    if (data.user.Name === "") {
      hideLoader();
      WarningMessage("Please enter property name")
      return;
    }
    if (data.user.PhoneNumber.length < 10 || data.user.PhoneNumber.length > 10 && data.user.PhoneNumber.length > 0) {
      hideLoader();
      WarningMessage("Please enter valid phone number")
      return;
    }

    const res = await httpService
      .CreateUpdate("SaveProperty", data)
      .catch((err) => {
        return;
      });
    togglepropertyedit();
    props.getAllPropertyData();
    hideLoader();
    if (res.data.message === "Successful") {
      SuccessMessage("Property Added Successfully")
      getLicensedProperty();
    } else if (res.data.message) {
      WarningMessage(res.data.message)
      return
    }
  };

  const UpdateChannelruleForChannel = async (e, ruleDelete) => {
    e.preventDefault();
    //validation for not selecting a single rule
    if (ruleSelectedValue.length === 0) {
      ErrorMessage('Please select a Rule !')
      return;
    }
    //need a validation for 'deselecting a rule' or 'not selecting a rule' or 'deselecting and then selecting a rule'
    showLoader();
    let data = {
      id: channelIdforRule,
      // ruleid: channelRuleExisting,
      // ChannelRulesName: channelRuleName,
      ruleForProperty: ruleForProperty,
      ruleDelete: ruleDelete,
      channelRules: ruleSelectedValue
    };
    const res = await httpService
      .CreateUpdate("UpdateChannelRuleforChannel", data)
      .catch((err) => {
        return;
      });
    setchannelIdforRule("");
    setchannelRuleExisting("");
    toggleRuleEditModal();
    props.getAllPropertyData();
    if (res.data.message === "Successful") {
      SuccessMessage("Selected rule updated successfully")
      hideLoader();
      return;
    }

  }
  let dlvalue = true;
  const toggleChannel = async (event, index) => {
    event.preventDefault();
    let classes = [...props.sidebarClassesChannel];
    let y = [...props.channelsButtons];
    if (classes[index] === "1") {
      for (let i = 0; i < classes.length; i++) {
        classes[i] = "0";
        y[i] = "fa-plus-circle";
      }
    } else {
      for (let i = 0; i < classes.length; i++) {
        classes[i] = "0";
        y[i] = "fa-plus-circle";
      }
      classes[index] = "1";
      y[index] = "fa-minus-circle";
    }
    props.setsidebarClassesChannel(classes);
    props.setchannelsButtons(y);
    localStorage.setItem("channelsButtons", y);
    localStorage.setItem("channelsClasses", classes);
  };

  const toggleRow = (event, index, x) => {
    event.preventDefault();
    if (!(x == 2 && localStorage.getItem('userClasses').split(',')[index] == '1')) {
      let classes = [...propertyClasses];
      let y = [...props.userButtons];
      for (let i = 0; i < classes.length; i++) {
        if (i !== index) {
          classes[i] = "none";
          y[i] = "fa-plus-circle";
        }
      }
      y[index] = classes[index] === "none" ? "fa-minus-circle" : "fa-plus-circle";
      classes[index] = classes[index] === "none" ? "" : "none";
      if (classes[index] === "none") {
        let x = [...props.sidebarClassesUser];
        for (let i = 0; i < x.length; i++) {
          x[i] = "0";
        }
        props.setsidebarClassesUser(x);
        localStorage.setItem("userClasses", x);
      } else {
        let x = [...props.sidebarClassesUser];
        for (let i = 0; i < x.length; i++) {
          x[i] = "0";
        }
        x[index] = "1";
        props.setsidebarClassesUser(x);
        localStorage.setItem("userClasses", x);
      }

      let arrowclasses = [...arrowClasses];
      for (let i = 0; i < arrowclasses.length; i++) {
        if (i !== index) {
          arrowclasses[i] = "faPlusCircle";
        }
      }
      arrowclasses[index] =
        classes[index] === "none" ? "faPlusCircle" : "faMinusCircle";

      let userclasses = [...userClasses];
      for (let i = 0; i < userClasses.length; i++) {
        if (i !== index) {
          userClasses[i] = "btn-100 btn btn-secondary";
        }
      }
      userclasses[index] =
        classes[index] === "none"
          ? "btn-100 btn btn-secondary"
          : "btn-100-active btn btn-secondary";
      setUserClasses(userclasses);
      setArrowClasses(arrowclasses);
      setPropertyClasses(classes);
      props.setuserButtons(y);
      localStorage.setItem("userButtons", y);
      localStorage.setItem("dashboardUserClasses", userclasses);
      localStorage.setItem("dashboardArrowClasses", arrowclasses);
      localStorage.setItem("dashboardPropertyClasses", classes);
    }
  };

  const onInputChange1 = (e) => {
    setOnclickData({ ...onClickData, [e.target.name]: e.target.value });
  };

  const addClickHandler1 = (e) => {
    setSave3(true);
    setOnclickProperty({
      Name: "",
      Address1: "",
      Address2: "",
      Country: "",
      State: "",
      City: "",
      Zip: "",
      PhoneNumber: "",
      Email: "",
      ContactName: "",
      userId: e._id,
    });
    togglepropertyedit();

  };

  const addClickHandler = (e) => {
    PropertyArray(e, e._id);
    setPropertyVal([]);
    setSave(true);
    settoggleChannelShow(true);
    setDefaultVal([]);
    setSelectedPropertyValues([])
    setOnclickData({
      channelName: "",
      channelDescription: "",
      channel_category: "",
      channel_language: "",
      programIcon: "",
      videoSource: [],
      program: [],
      RuleType: [],
      PropertyType: [],
      billboard: [],
      userId: e._id,
    });

  };

  const handleStartTime = (e, i) => {
    if (e) {
      let ChannelData = { ...onClickData };
      ChannelData.program[i].startTime = e.substring(0, 5);
      setOnclickData(ChannelData);
      if (ChannelData.program[i].endTime) {
        let startTime = e;
        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endTime = ChannelData.program[i].endTime;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.program[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.program[i].duration = duration;
        }
      }
    }
  };

  const onInputChange = (e) => {
    setSelectedValue(e.target.value);
    setOnclickData({ ...onClickData, [e.target.name]: e.target.value });
  };

  var rulearray = ["IpAddress", "MacAddress", "AccountNumber", "Geo_Location"];
  const ruleSelectValues = [
    { value: "IpAddress", label: "IP Address" },
    { value: "MacAddress", label: "Mac Address" },
    { value: "AccountNumber", label: "Account Number" },
    { value: "Geo_Location", label: "Geo Location(Lat Long)" },
  ];

  const handleEndTime = (e, i) => {
    if (e) {
      let ChannelData = { ...onClickData };
      ChannelData.program[i].endTime = e.substring(0, 5);
      setOnclickData(ChannelData);
      if (ChannelData.program[i].startTime) {
        let endTime = e;
        let startTime = ChannelData.program[i].startTime;

        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.program[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.program[i].duration = duration;
        }
      }
    }
  };
  const addprogram = async () => {
    let ChannelData = { ...onClickData };
    ChannelData.program.push({
      title: "",
      language: "",
      duration: 0,
      startTime: "00:00",
      endTime: "00:00",
      description: "",
    });
    setOnclickData(ChannelData);
  };

  const addbillboard = async () => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard.push({
      billboard: "",
      billboard_name: "",
      startTime: "00:00",
      endTime: "23:59",
      Timezone: "",
    });
    setOnclickData(ChannelData);
  };
  const removeProgram = (index) => {
    let ChannelData = { ...onClickData };
    ChannelData.program.splice(index, 1);
    setOnclickData(ChannelData);
  };
  const handleChangeBillboard = (e, i, name, billboard_name) => {
    let linknamechange = e.value;
    //let flag1 = e.innerText;
    let label = linknamechange.split(" (")[0].trim();
    let linkValue1 = linknamechange.split(" (")[1].trim();
    let linkValue = linkValue1.split(")")[0];
    let ChannelData = { ...onClickData };
    ChannelData.billboard[i][`${name}`] = linkValue;
    ChannelData.billboard[i][`${billboard_name}`] = label;
    console.log('channeldata', ChannelData);
    setOnclickData(ChannelData);
  };

  const handletimezoneChange = (e, i, name) => {
    // let ChannelData = { ...onClickData };
    // ChannelData.billboard[i][`${name}`] = e;
    // setOnclickData(ChannelData);
    let ChannelData = { ...onClickData };
    if (name === 'Timezone')
      ChannelData.billboard.forEach(ele => ele[`${name}`] = e);
    else
      ChannelData.billboard[i][`${name}`] = e;
    setOnclickData(ChannelData);
  }
  const handlelayoutTypechange = (e, i, name, type) => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard[i][`${name}`] = type;
    setOnclickData(ChannelData);
  }


  const handlebillboardstarttime = (elem, i) => {
    const dateObj = new Date(elem);
    const hhmm = dateObj.toTimeString().slice(0, 5);
    if (elem) {
      let ChannelData = { ...onClickData };
      ChannelData.billboard[i].startTime = hhmm;
      setOnclickData(ChannelData);
      // if(ChannelData.billboard[i].startTime > 12){
      //   elem.toLocaleString('en-US', { hour: 'numeric', hour12: true , minute: 'numeric' })
      // }

      if (ChannelData.billboard[i].endTime) {
        let startTime = hhmm;
        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endTime = ChannelData.billboard[i].endTime;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.billboard[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.billboard[i].duration = duration;
        }
      }
    }
  }



  const handlebillboardendtime = (elem, i) => {
    const dateObj = new Date(elem);
    const hhmm = dateObj.toTimeString().slice(0, 5);
    if (elem) {
      let ChannelData = { ...onClickData };
      ChannelData.billboard[i].endTime = hhmm;
      setOnclickData(ChannelData);
      // if(ChannelData.billboard[i].endTime > 12){
      //   elem.toLocaleString('en-US', { hour: 'numeric', hour12: true })
      // }
      if (ChannelData.billboard[i].startTime) {
        let endTime = hhmm;
        let startTime = ChannelData.billboard[i].startTime;

        let startHour =
          parseInt(startTime.split(":")[0]) +
          parseInt(startTime.split(":")[1]) / 60;
        let endHour =
          parseInt(endTime.split(":")[0]) +
          parseInt(endTime.split(":")[1]) / 60;
        if (endHour >= startHour) {
          let duration = Math.round((endHour - startHour) * 60);
          ChannelData.billboard[i].duration = duration;
        } else {
          let duration = Math.round((endHour - startHour + 24) * 60);
          ChannelData.billboard[i].duration = duration;
        }
      }
    }
  }

  const timeZone = [
    {
      label: "Select Timezone",
      value: "",
    },
    {
      label: "Eastern Time",
      value: "EST",
    },
    {
      label: "Central Time",
      value: "CST",
    },
    {
      label: "Mountain Time",
      value: "MST",
    },
    {
      label: "Pacific Time",
      value: "PST",
    }, {
      label: "Alaska Time",
      value: "AKST",
    }, {
      label: "Hawaii Time",
      value: "HST",
    },
  ];

  const handleChangeProgram = (e, i, name) => {
    let ChannelData = { ...onClickData };
    ChannelData.program[i][`${name}`] = e;
    setOnclickData(ChannelData);
  };
  const ischecked = (event) => {
    if (event.target.value === "billboard") {
      let ChannelData = { ...onClickData };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setOnclickData(ChannelData);
      if (ChannelData.billboard.length == 0) {
        addbillboard();
      }
    }
    if (event.target.value === "url") {
      let ChannelData = { ...onClickData };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setOnclickData(ChannelData);
      DeleteAllBillboards()
    }
    if (event.target.value === "encoder") {
      let ChannelData = { ...onClickData };
      ChannelData.videoSource[0] = event.target.value;
      ChannelData.videoSource[1] = "";
      setOnclickData(ChannelData);
      DeleteAllBillboards()
    }
  };
  const handleC = (e) => {
    let ChannelData = { ...onClickData };
    ChannelData.channel_category = e.target.value;
    setOnclickData(ChannelData);
  };
  const handleC1 = (e) => {
    let ChannelData = { ...onClickData };
    ChannelData.channel_language = e.target.value;
    setOnclickData(ChannelData);
  };
  const Deletebillboarddata = async (event, i) => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard.splice(i, 1);
    setOnclickData(ChannelData);
  };
  const DeleteAllBillboards = async () => {
    let ChannelData = { ...onClickData };
    ChannelData.billboard = [];
    setOnclickData(ChannelData);
  };
  const DeleteChannelRow = async (delId, propDelId) => {
    showLoader();
    let data = {
      id1: delId,
      propertyId: propDelId
    };
    if (delId) {
      const res = await httpService
        .CreateUpdate("DeleteChannelRow", data)
        .catch((err) => {
          return;
        });
      props.getAllPropertyData();
      settoggleChannelDelete(false);
      if (res.data.message === "Successful") {
        SuccessMessage("Channel Deleted Successfully");
        hideLoader();
        return;
      }
    }
    setDelId('');
  };


  const columns = [
    {
      headerName: "Rule Name",
      field: "ChannelRulesName",
      sortable: "true",
      tooltipField: "ChannelRulesName"
    },
    {
      headerName: "Account Number",
      field: "RuleType.AccountNumber",
      tooltipField: "RuleType.AccountNumber"

    },
    {
      headerName: "Mac-Address",
      field: "RuleType.MacAddress",
      tooltipField: "RuleType.MacAddress"

    },
    {
      headerName: "Ip Address",
      field: "TableIp",
      tooltipField: "TableIp"

    },
    {
      headerName: "Geo-Location",
      field: "RuleType.Geo_Location",
      tooltipField: "RuleType.Geo_Location"

    },
    {
      headerName: "Edit ",
      field: "Edit",
      cellRenderer: (params) => {
        if (params.data.ChannelRulesName !== 'Billing System') {
          let span = document.createElement("div");
          span.className = " deleteUser";
          let img = document.createElement("i");
          img.className = "fa fa-edit";

          img.onclick = (event) => {
            setOnClickAddAndEditMsg("Edit Rule")
            addClickHandler4(event, params.data)
            setSave1(false)
          };

          span.appendChild(img);
          return span;
        }
      },
    },

    {
      headerName: "Delete",
      suppressMenu: true,
      suppressSorting: true,
      cellRenderer: (params) => {
        if (params.data.ChannelRulesName !== 'Billing System') {
          let span = document.createElement("div");
          span.className = "spanname deleteUser";
          let img = document.createElement("i");
          img.className = "fa fa-trash delete-icon";
          img.onclick = (event) => {
            DeleteConfirmationDialog("rule", "Are you sure want to delete this rule?", event, params.data)
          };
          span.appendChild(img);
          return span;
        }
      },

      maxWidth: 100,
    },

  ];


  let baseImage = "";
  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };


  let checkTimeOverLaping = () => {
    return TimeOverLaping(onClickData.billboard);
  };

  const UpdateChannelinfo = async () => {
    if (onClickData.PropertyType.length == 0) {
      WarningMessage("Please Select Property Name")
      return;
    } else if (!onClickData.channelName) {
      WarningMessage("Please Enter Channel Name");
      return;
    } else if (!onClickData.channelID) {
      WarningMessage("Please Enter Channel ID");
      return;
    }
    else if (onClickData.videoSource.length === 0) {
      WarningMessage("Please Select atleast one Videosource")
      return;
    }
    if (onClickData.videoSource[0] == "billboard") {
      console.log(onClickData.billboard)
      if (onClickData.billboard.length === 0) {
        WarningMessage("Please  Add  Billboards  Time !");
        return;
      }
      if ((onClickData.billboard[0].billboard_name == "" && onClickData.billboard[0].billboard == "") || (onClickData.billboard[onClickData.billboard.length - 1].billboard_name == "" && onClickData.billboard[onClickData.billboard.length - 1].billboard == "")) {
        WarningMessage("Please  Choose Layout OR Input Url !");
        return;
      } else if (onClickData.billboard[0].Timezone == "") {
        WarningMessage("Please  Select  Time Zone !");
        return;
      }
    }
    if (onClickData.videoSource[0] == "billboard" && checkTimeOverLaping()) return
    showLoader();
    let data = {
      id1: onClickData._id,
      program: onClickData,
    };

    let data1 = data.program.channelName
      .trim()
      .split("  ")
      .filter((word) => word !== "");
    data.program.channelName = data1.join(" ");
    if (data.program.videoSource[0] === "encoder" || data.program.videoSource[0] === "url") {
      hideLoader();
      if (!validator.isURL(data.program.videoSource[1])) {
        WarningMessage("Please enter a  valid Url !");
        return;
      }
    }
    let validTimeForProgram = await CommonUtils.bilboardProgramTimeValidation(onClickData);
    if (validTimeForProgram) { return }

    const res = await httpService
      .CreateUpdate("UpdateChannelRow", data).catch((err) => {
        return;
      });
    props.getAllPropertyData();
    settoggleChannelShow(false);
    if (res.data.message === "Successful") {
      SuccessMessage("Channel Updated successfully")
      hideLoader();
      return;
    } else if (res.data.message) {
      WarningMessage("Channel name already exist")
    }
  };


  const DeleteRule = async (event, e) => {
    showLoader();
    let data = {
      id1: e._id,
    };
    const res = await httpService
      .CreateUpdate("DeleteRule", data)
      .catch((err) => {
        return;
      });
    props.getAllPropertyData();
    if (res.data.message === "Successful") {
      SuccessMessage("Channel Rule Deleted Successfully");
      hideLoader();
      return;
    }

  };
  const getFile = async (e) => {
    const file = e.target.files[0];
    if (file) {
      await getBase64(file)
        .then((result) => {
          baseImage = result;
          let data = { ...onClickData };
          data.programIcon = baseImage;
          setOnclickData(data);
        })
        .catch((err) => {
          return;
        });
    }
  };
  const DeleteProperty = async (e) => {

    let data = {
      id1: e,
    };
    showLoader();
    const res = await httpService
      .CreateUpdate("DeleteProperty", data)
      .catch((err) => {
        return;
      });
    if (res.data.message === "Successful") {
      props.getAllPropertyData();
      SuccessMessage("Property Deleted Successfully")
      getLicensedProperty()
    }
    hideLoader();
  };

  const DeleteConfirmationDialog = async (msg, titileMsg, v, item) => {
    Swal.fire({
      title: titileMsg,
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        if (msg === "property") {
          DeleteProperty(item);
        } else if (msg == "rule") {
          DeleteRule(v, item)
        } else if (msg === "Channel") {
          DeleteChannelRow(v, item)
        }
        else if (msg === "billboard") {
          Deletebillboarddata(v, item)
        }
      }
    })
  };

  const IPformatFun = (e) => {
    let ChannelData = { ...onClickRuleData };
    ChannelData.RuleType["IpAddress"] = {};
    { IPFormatVal ? ChannelData.RuleType["IpAddress"][e.target.value] = IPFormatVal : ChannelData.RuleType["IpAddress"][e.target.value] = ""; }      // setOnclickRuleData(ChannelData); 
    setIPFormatData(e.target.value);
    setIPFormatV(e.target.value);
    if (e.target.value === "SingleIpAddress") {
      setIpAddressPlaceHolder('255.255.255.0')
      setIpAddressNote('')
    } else if (e.target.value === "IpAddressRange") {
      setIpAddressPlaceHolder('255.255.255.0-255.255.255.255')
      setIpAddressNote("i.e please enter XXX.XXX.XXX.XXX<->XXX.XXX.XXX.XXX")
    } else if (e.target.value === "CIDR") {
      setIpAddressPlaceHolder('255.255.255.0/XX')
      setIpAddressNote("i.e please enter XXX.XXX.XXX.XXX/XX")
    }
  }

  const setIPvalue = (e, IPFormatData) => {
    if (IPFormatData == "SingleIpAddress") {
      let data = CommonUtils.IPValidation(e.target.value)
      if (data) {
        return
      }
    } else if (IPFormatData == "IpAddressRange") {
      if (CommonUtils.IPValidationForRange(e.target.value)) {
        return
      }
    } else if (IPFormatData == "CIDR") {
      if (CommonUtils.IPValidationWithCIDR(e.target.value)) {
        return
      }
    }
    let ChannelData = { ...onClickRuleData };
    ChannelData.RuleType["IpAddress"] = {};
    ChannelData.RuleType["IpAddress"][IPFormatData] = e.target.value;
    setOnclickRuleData(ChannelData);
    setIPFormatVal(e.target.value)
  }

  const handleShow3 = (e, item) => {
    setSave3(false);
    setOnclickProperty(item);
    togglepropertyedit();
  };
  const onInputChange3 = (e) => {
    setOnclickProperty({ ...onClickProperty, [e.target.name]: e.target.value });
  };




  const addClickHandler2 = (e) => {

    setDefaultVal([]);
    setIPFormatDataValue([]);
    setIPFormatV([]);
    setIPFormatVal([])
    setOnclickRuleData({
      ChannelRulesName: "",
      RuleType: {},
      UserId: e._id
    });
    setSave1(true);
    toggleRuleEdit();
  };
  const addClickHandler4 = (e, data1) => {
    let itemdata = props.allData.ruleData.filter(data => {
      if (data._id === data1._id) {
        return data
      }
    })
    let data = { ...itemdata[0] }
    if (data.RuleType.IpAddress) {
      let IPValidValue = Object.entries(data.RuleType.IpAddress);
      setIPFormatDataValue(IPValidValue);
      setIPFormatV(IPValidValue[0][0]);
      setIPFormatVal(IPValidValue[0][1])
    } else {
      setIPFormatDataValue([]);
      setIPFormatV([]);
      setIPFormatVal([])
    }

    if (data.RuleType) {
      let selectedKeys = Object.keys(data.RuleType);
      let arr = [];
      for (let i = 0; i < selectedKeys.length; i++) {
        let obj = {
          value: selectedKeys[i],
          label: selectedKeys[i],
        };

        if (selectedKeys[i] != "Deviation" && selectedKeys[i] != "Geo_Location_Original") {
          let ChannelData = { ...onClickRuleData };
          ChannelData[selectedKeys[i]] = data.RuleType[selectedKeys[i]];
          setOnclickRuleData(ChannelData);
          arr.push(obj);
        }
      }
      setSelectedRuleValues(arr);
      setDefaultVal(arr);
    }



    setOnclickRuleData(data);
    if (!data.RuleType) {
      let ChannelData = { ...data };
      ChannelData["RuleType"] = {};
      setOnclickRuleData(ChannelData);
    }
    toggleRuleEdit();
  }

  const saveProgram = async () => {
    if (onClickData.PropertyType.length === 0) {
      hideLoader();
      WarningMessage("Please Select Property Name");
      return;
    } else if (!onClickData.channelName) {
      hideLoader();
      WarningMessage("Please Enter Channel Name")
      return;
    } else if (!onClickData.channelID) {
      WarningMessage("Please Enter ChannelID")
      return;
    }
    else if (onClickData.videoSource.length === 0) {
      WarningMessage("Please Select atleast one Videosource")
      return;
    }
    if (onClickData.videoSource[0] == "billboard") {
      console.log(onClickData.billboard)
      if (onClickData.billboard.length === 0) {
        WarningMessage("Please  Add  Billboards  Time !");
        return;
      }
      if ((onClickData.billboard[0].billboard_name == "" && onClickData.billboard[0].billboard == "") || (onClickData.billboard[onClickData.billboard.length - 1].billboard_name == "" && onClickData.billboard[onClickData.billboard.length - 1].billboard == "")) {
        WarningMessage("Please  Choose Layout OR Input Url !");
        return;
      } else if (onClickData.billboard[0].Timezone == "") {
        WarningMessage("Please  Select  Time Zone !");
        return;
      }
    }
    if (onClickData.videoSource[0] == "billboard" && checkTimeOverLaping()) return
    showLoader();
    let data = {
      data: onClickData,
      UserId: onClickData.userId,
    };

    let data1 = data.data.channelName
      .trim()
      .split("  ")
      .filter((word) => word !== "");
    data.data.channelName = data1.join(" ");
    if (data.data.videoSource[0] === "encoder" || data.data.videoSource[0] === "url") {
      hideLoader();
      if (!validator.isURL(data.data.videoSource[1])) {
        WarningMessage("Please enter a  valid Url !");
        return;
      }
    }

    let validTimeForProgram = await CommonUtils.bilboardProgramTimeValidation(onClickData);
    if (validTimeForProgram) { return }

    const returndata = await httpService
      .CreateUpdate("getInfoapi", data)
      .catch((err) => {
        return;
      });

    settoggleChannelShow(false);
    props.getAllPropertyData();
    if (returndata.data.message === "Successful") {
      SuccessMessage("Channel Added Successfully")
      hideLoader();
      return;
    } else if (returndata.data.message) {
      WarningMessage(returndata.data.message);
      hideLoader();
      return;
    }
  };

  const Updateproperty = async () => {
    showLoader();
    let data = {
      id: onClickProperty._id,
      user: onClickProperty,
    };
    let data1 = data.user.Name.trim()
      .split("  ")
      .filter((word) => word !== "");
    data.user.Name = data1.join(" ");
    if (data.user.Name === "") {
      hideLoader();
      WarningMessage("Please enter property name")
      return;
    }
    if (data.user.PhoneNumber.length < 10 || data.user.PhoneNumber.length > 10) {
      hideLoader();
      WarningMessage("Please enter valid phone number");
      return;
    }
    const res = await httpService
      .CreateUpdate("UpdateProperty", data)
      .catch((err) => {
        return;
      });

    props.getAllPropertyData();
    togglepropertyedit();
    if (res.data.message === "Successful") {
      SuccessMessage("Property updated successfully")
      hideLoader();
      return;
    } else if (res.data.message) {
      WarningMessage(res.data.message);
      hideLoader();
      return;
    }

  };
  const handleRuleSelect = (selectedValue) => {

    const selectedValues = selectedValue.map(obj => obj.value);

    if (selectedValues.includes("AccountNumber")) {
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["AccountNumber"] = commonUtiles.generateAccountNumber();
      setOnclickRuleData(ChannelData);
    }
    setSelectedRuleValues(selectedValue);
    let dataArrr = [];
    for (let j = 0; j < selectedValue.length; j++) {
      dataArrr.push(selectedValue[j]);
    }
    for (let i = 0; i < 4; i++) {
      if (onClickRuleData.RuleType[rulearray[i]]) {
        let flag = true;
        for (let j = 0; j < selectedValue.length; j++) {
          if (selectedValue[j].value === rulearray[i]) {
            flag = false;
          }
          // dataArrr.push(selectedValue[j]);
        }
        if (flag) {
          let checkKey = Object.keys(onClickRuleData.RuleType)
          if (checkKey[0] == "IpAddress") {
            setIPFormatV('')
          }
          delete onClickRuleData.RuleType[rulearray[i]];
        }
      }
    }
    setDefaultVal(dataArrr);
  };

  const saveChannelRule = async () => {
    let validInput = await CommonUtils.validateRule(onClickRuleData);
    if (!validInput) { return }

    showLoader();
    let UserId = onClickRuleData.UserId;
    let data = {
      userId: UserId,
      user: onClickRuleData,
    };
    if (selectedRuleValues.length > 2) {
      hideLoader();
      WarningMessage("Please create a rule with two factor or single factor.")
      return false;
    }
    if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length != 2) {
      hideLoader();
      WarningMessage("Enter Geo Location in proper format")
      return;
    } else if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length === 2) {
      onClickRuleData.RuleType["Geo_Location_Original"] = {
        longitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        longitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
      }
    }
    const res = await httpService
      .CreateUpdate("SaveChannelRule", data)
      .catch((err) => {
        return;
      });
    hideLoader();
    if (res.data.ack === "2") {
      hideLoader();
      WarningMessage(res.data.message);
      return;
    } else if (res.data.ack === "3") {
      hideLoader();
      WarningMessage(res.data.message)
      return;
    } else if (res.data.message1 && res.data.message1 === "Account number matched") {
      hideLoader();
      WarningMessage("Account number matched")
      return;
    } else {
      SuccessMessage("Channel rule created successfully")
    }
    toggleRuleEdit();
    setSave1(false);
    props.getAllPropertyData();
    setSelectedRuleValues([]);
    setDefaultVal([]);
    setIPFormatV([]);
    setIPFormatVal([]);
  };

  const UpdateChannelrule = async () => {
    let validInput = await CommonUtils.validateRule(onClickRuleData);
    if (!validInput) { return }
    showLoader();
    let data = {
      userId: onClickRuleData.userId,
      user: onClickRuleData,
    };
    let data1 = data.user.ChannelRulesName.trim()
      .split("  ")
      .filter((word) => word !== "");
    data.user.ChannelRulesName = data1.join(" ");
    if (selectedRuleValues.length > 2) {
      hideLoader();
      WarningMessage("Please create a rule with two factor or single factor.")
      return false;
    }

    if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length != 2) {
      hideLoader();
      WarningMessage("Enter Geo Location in proper format")
      return;
    } else if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length === 2) {
      onClickRuleData.RuleType["Geo_Location_Original"] = {
        longitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        longitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
        latitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
      }
    }
    const res = await httpService
      .CreateUpdate("getruleapi", data)
      .catch((err) => {
        return;
      });
    hideLoader();

    if (res.data.ack === '1') {
      hideLoader();
      SuccessMessage(res.data.message)
    } else if (res.data.ack === '2') {
      WarningMessage(res.data.message)
      hideLoader();
    } else if (res.data.ack === '3') {
      WarningMessage(res.data.message)
      hideLoader();
    } else {
      WarningMessage("Something went wrong!")
      hideLoader();
    }

    toggleRuleEdit();
    props.getAllPropertyData();
    setSelectedRuleValues([]);
    setDefaultVal([]);
    setIPFormatV([]);
    setIPFormatVal([]);
  };

  const onInputRuleChange = (e) => {
    setSelectedValue(e.target.value);
    setOnclickRuleData({ ...onClickRuleData, [e.target.name]: e.target.value });
  };

  const handlec2 = (e) => {
    if (e.target.name === "IpAddress") {
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["IpAddress"] = e.target.selectedValue;
      setOnclickRuleData(ChannelData);
    }
    if (e.target.name === "MacAddress") {
      if (CommonUtils.MacValidation(e.target.value)) return;
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["MacAddress"] = e.target.value.toUpperCase();
      setOnclickRuleData(ChannelData);
    }
    if (e.target.name === "AccountNumber") {
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["AccountNumber"] = e.target.value;
      setOnclickRuleData(ChannelData);
    }
    if (e.target.name === "Geo_Location") {
      if (e.target.value.match(/[^0-9. -]/) || e.target.value.split(' ').length > 2 ||
        e.target.value.split(' ')[0].length != 1 && isNaN(e.target.value.split(' ')[0]) ||
        (e.target.value.split(' ').length === 2 && (e.target.value.split(' ')[0].length != 1 &&
          isNaN(e.target.value.split(' ')[0]) || e.target.value.split(' ')[1].length != 1 && isNaN(e.target.value.split(' ')[1])))
      ) {
        return
      } else {
        let ChannelData = { ...onClickRuleData };
        ChannelData.RuleType["Geo_Location"] = e.target.value;
        setOnclickRuleData(ChannelData);
      }
    }
    if (e.target.name === "Deviation") {
      let ChannelData = { ...onClickRuleData };
      ChannelData.RuleType["Deviation"] = e.target.value;
      setOnclickRuleData(ChannelData);
    }
  };
  const handleselectedR = (selectedValue) => {
    let ruleArray = [];
    for (let j = 0; j < selectedValue.length; j++) {
      ruleArray.push(selectedValue[j]);
    };
    setRuleSelectedValue(ruleArray);
  }

  const GetAllLayout = async () => {
    let layout = await httpService.getByBoj('getSelectedLayout', {})
      .then((res) => res.data.data)
      .catch((err) => {
        if (err && err.response && err.response.status == 401) {
          ErrorMessage("Session expired, please login again")
        }
      })

    if (layout) {
      setLayouts(layout)
    }
  }

  const toggleeditLayoutPropPass = (name) => {
    if (!modaleditLayoutPropPass) {
      setlayoutLocalReplicate(name + " - Copy");
    }
    setmodaleditLayoutPropPass((prevState) => !prevState)
  }

  const replicateLayout = async (item) => {
    setReplicateData(item)
    toggleeditLayoutPropPass(item.name);
    setReplicateProperty('');
    setReplicateUser('')
  }

  const ProceedToThisLayoutReplicate = async () => {
    if (!layoutLocalReplicate) {
      ErrorMessage('Please enter a Name !')
      return;
    }
    if (!replicateUser) {
      ErrorMessage('Please select user !')
      return;
    }
    if (!replicateProperty) {
      ErrorMessage('Please select a property !')
      return;
    }
    let x = props.allData.property.filter((ele) => ele._id === replicateProperty)
    let array = []
    array.push({ value: replicateProperty, label: x[0].Name, PropertyId: replicateProperty })
    let data = {
      layoutId: replicateData._id,
      selectedLayout: replicateData.selectedLayout,
      name: layoutLocalReplicate,
      propertyData: array,
      userID: replicateUser
    };
    const Layout = await httpService
      .CreateUpdate("saveSelectedLayout", data)
      .then((res) => {
        SuccessMessage("Layout Copied Successfully !")
      })
      .catch((err) => {
        console.log(err);
      });
    GetAllLayout();
    setlayoutLocalReplicate("");
    setmodaleditLayoutPropPass(false);
    setReplicateProperty('');
    setReplicateUser('')
  };

  const removeLayout = async (layout_id) => {
    let res = window.confirm('Do you want to delete this Layout ?')
    if (!res) {
      return;
    }
    let dataPost = {
      layout_id: layout_id,
    };
    let widgetdata = await httpService
      .CreateUpdate("removelayoutAPI", dataPost)
      .then((res) => {
        SuccessMessage("Layout Deleted Successfully !");
      })
      .catch((err) => {
        return;
      });
    GetAllLayout();
  };
  const inputValidation = (e) => {
    if (e.target.selectionStart === 0 && e.key === " ") {
      e.preventDefault();
    }
    if (e.key.match(/[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/)) {
      e.preventDefault();
    }
  }
  const getNasFile = async (data) => {
    let res = await httpService.get(`/nas/list?path=${NasUser}`)
      .then((res) => res?.data?.data)
      .catch((err) => {
        ErrorMessage(err.response.data);
        return null;
      });

    console.log("res : ", res)
    // if (data.format === "image") {
    //   const allImageFiles = res?.files.filter((item) => {
    //     const fileSplit = item.additional.type.toLowerCase();
    //     return data.type.includes(fileSplit);
    //   });
    //   if (allImageFiles.length === 0) {
    //     WarningMessage("There is no image file. Please upload it first.");
    //     return
    //   }
    //   setFiles(allImageFiles);
    // }
  };

  const handleOpenPickerLocalServer = () => {
    const data = {
      type: ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"],
      format: "image",
    };
    setShowPicker(true);
    getNasFile(data);
  };

  const handleSelectFile = (fileName) => {
    setSelectedFiles((prevSelected) => ({
      ...prevSelected,
      [fileName]: !prevSelected[fileName],
    }));
  };

  const handleLocalSubmit = () => {
    const selected = Object.keys(selectedFiles).filter(
      (fileName) => selectedFiles[fileName]
    );

    let name = selected[0]?.replace(",", "/");
    const URL = `${window.location.origin}/api/v1/nas/download?path=` + name;
    let data1 = { ...onClickData };
    data1.programIcon = URL;
    setOnclickData(data1);

    setShowPicker(false);
    setSelectedFiles({});
  }

  return (
    <div className={"pad-15 mainDiv"}>
      {loading ? <Loader /> : null}
      <div className="boxplate " style={{ margin: "15px" }}>
        <div className="boxplate-heading" style={{ fontSize: "large" }}>
          Super Admin
        </div>
        <div className="pad-new">
          {props.allData &&
            Object.keys(props.allData).length > 0 &&
            props.allData.users.map((value, index) => {
              return (
                <div hidden={value.type === "admin" || value.customerId === "Admin"}>
                  <div class="col-sm-12">
                    <div className="posrel">
                      <button
                        key={index}
                        className={userClasses[index]}
                        onClick={() => { }}
                        style={{ display: "flex" }}
                      >
                        <div onClick={(event) => {
                          toggleRow(event, index)
                          // setUserID(value._id)
                        }} style={{ flexGrow: "1" }}>

                          {value.customerId.length < 30
                            ? value.customerId
                            : value.customerId.substring(0, 30) + "...."}
                        </div>
                        <div
                          className="text-end"
                          style={{ position: "relative", float: "right" }}
                        >
                          <div
                            style={{ display: "inline", marginRight: "15px" }}
                          >
                            <button
                              className="btn btn-sm buttonAdmin"
                              hidden={hideProperty}
                              onClick={(event) => {
                                toggleRow(event, index, 2)
                                setOnClickAddAndEditMsg("Add Property")
                                addClickHandler1(value);
                              }}
                            >
                              Add Property
                            </button>
                            <button
                              className="btn btn-sm buttonAdmin ms-2"
                              onClick={(event) => {
                                toggleRow(event, index, 2)
                                setOnClickAddAndEditMsg("Add Channel")
                                addClickHandler(value)
                              }}
                            >
                              Add Channel
                            </button>
                            <button
                              className="btn btn-sm buttonAdmin ms-2"
                              onClick={(event) => {
                                toggleRow(event, index, 2)
                                setOnClickAddAndEditMsg("Create Rule")
                                setIpAddressNote('')
                                addClickHandler2(value)
                              }}
                            >
                              Create Rule
                            </button>
                          </div>
                          <div style={{ display: "inline" }} onClick={(event) => toggleRow(event, index)}>
                            <FontAwesomeIcon
                              style={{ display: "inline" }}
                              className="faviconright font-centered"
                              icon={
                                arrowClasses[index] === "faPlusCircle"
                                  ? faPlusCircle
                                  : faMinusCircle
                              }
                            />
                          </div>
                        </div>
                      </button>
                    </div>

                    <div
                      key={"property" + index}
                      style={{ display: propertyClasses[index] }}
                    >
                      <Card className="card-this" style={{ padding: "0 20px" }}>
                        <CardBody>
                          <div className="table-responsive border" style={{
                            overflowX: 'auto',
                            maxHeight: '250px',
                          }}>
                            <Table className="table-inner">
                              <thead className="bg-header" style={{ position: 'sticky', top: '0', zIndex: '5' }}>
                                <tr>
                                  <th>Layout Name</th>
                                  <th>Replicate Layout</th>
                                  <th>View Layout</th>
                                  <th>Delete Layout</th>
                                </tr>
                              </thead>
                              <tbody className="font12"
                              >
                                {layouts.length > 0 && layouts.map((e, i) => {
                                  if (e.userID === value._id)
                                    return (
                                      <tr>
                                        <td>
                                          {e.name ? e.name : 'Layout'}
                                        </td>
                                        <td style={{ color: 'blue', cursor: "pointer" }}
                                        >
                                          <span onClick={() => replicateLayout(e)}>Copy</span>
                                        </td>
                                        <td style={{ paddingTop: "4px" }}>
                                          <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={`/view/${e._id}`}
                                          >
                                            View
                                          </Link>
                                        </td>
                                        <td>
                                          <Button
                                            color="danger"
                                            onClick={() => removeLayout(e._id)}
                                            style={{ transform: "scale(0.7)" }}
                                          >
                                            <FontAwesomeIcon
                                              className="icon"
                                              icon={faTrash}
                                              color="danger"
                                            />
                                          </Button>
                                        </td>
                                      </tr>
                                    );
                                })}
                              </tbody>
                            </Table>
                          </div>
                          <br></br>
                          <div className="table-responsive border">
                            <Table className="table-inner">
                              <thead className="bg-header">
                                <tr>
                                  <th>Property</th>
                                  <th>Country</th>
                                  <th>ZIP</th>
                                  <th>Contact No.</th>
                                  <th className="color-red">Email</th>
                                  <th>Edit</th>
                                  <th>Delete</th>
                                </tr>
                              </thead>
                              <div></div>
                              <tbody className="font12">
                                {props.allData.property.map((val, i) => {
                                  const userIdArray = Array.isArray(val.UserId) ? val.UserId : [val.UserId];
                                  if (userIdArray.includes(value._id) || val.associatedWith === value._id) {
                                    return (
                                      <>
                                        <tr
                                          key={i.toString() + index.toString()}
                                          className="pointer"
                                        >
                                          <td onClick={(event) =>
                                            loadSidebar(
                                              event,
                                              val.UserId,
                                              val._id,
                                              i
                                            )
                                          }>{val.Name}</td>
                                          <td onClick={(event) =>
                                            loadSidebar(
                                              event,
                                              val.UserId,
                                              val._id,
                                              i
                                            )
                                          }>
                                            {val.Country ? val.Country : ""}
                                          </td>
                                          <td onClick={(event) =>
                                            loadSidebar(
                                              event,
                                              val.UserId,
                                              val._id,
                                              i
                                            )
                                          }>
                                            {val["Zip"] ? val["Zip"] : ""}
                                          </td>
                                          <td onClick={(event) =>
                                            loadSidebar(
                                              event,
                                              val.UserId,
                                              val._id,
                                              i
                                            )
                                          }>
                                            {val.PhoneNumber
                                              ? val.PhoneNumber
                                              : ""}
                                          </td>
                                          <td onClick={(event) =>
                                            loadSidebar(
                                              event,
                                              val.UserId,
                                              val._id,
                                              i
                                            )
                                          }>{val.Email ? val.Email : ""}</td>
                                          <td>
                                            <button
                                              className="btn btn-sm btn-secondary"
                                              style={{
                                                transform: "scale(0.8)",
                                              }}
                                              onClick={(event) => {
                                                handleShow3(event, val)
                                                setOnClickAddAndEditMsg("Edit Property")
                                              }}
                                            >
                                              <i className="edit icon me-0"></i>
                                            </button>
                                          </td>
                                          <td>
                                            <button
                                              style={{
                                                transform: "scale(0.8)",
                                              }}
                                              className="btn btn-sm btn-danger"
                                              onClick={(event) => {
                                                DeleteConfirmationDialog("property", "Are you sure want to delete this  property?", event, val._id);

                                                // setPropId(val._id);
                                              }}
                                            >
                                              <i className="trash icon me-0"></i>
                                            </button>{" "}
                                          </td>
                                        </tr>
                                        <tr
                                          className={
                                            channelsClass[i] + " cluster-view"
                                          }
                                        >
                                          <td
                                            colSpan="9"
                                            className="form-boxtable-pad-15"
                                          >
                                            <div className="table-responsive border">
                                              <Table className="cluster-table">
                                                <thead className="bg-header">
                                                  <tr>
                                                    <th>Channel</th>
                                                    <th>Category</th>
                                                    <th>Language</th>
                                                    <th>Channel Description</th>
                                                    <th>Rules</th>
                                                    <th>Channel Statistics</th>
                                                    <th>Delete</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {props.allData.channels.map(
                                                    (v, idx) => {
                                                      const userIdArray = Array.isArray(val.UserId) ? val.UserId : [val.UserId];
                                                      if (
                                                        userIdArray.includes(v.UserId) &&
                                                        checkProperty(
                                                          v.PropertyType,
                                                          val._id
                                                        )
                                                      ) {
                                                        return (
                                                          <tr
                                                            onClick={(event) =>
                                                              toggleChannel(
                                                                event,
                                                                idx
                                                              )
                                                            }
                                                          >
                                                            <td
                                                              style={{
                                                                color: "blue",
                                                              }}
                                                              onClick={() => {
                                                                setOnClickAddAndEditMsg("Edit Channel")
                                                                channelUpdatefun(v);
                                                              }}
                                                            >
                                                              {v.channelName}
                                                            </td>
                                                            <td>
                                                              {v.channel_category
                                                                ? v.channel_category
                                                                : ""}
                                                            </td>
                                                            <td>
                                                              {v.channel_language
                                                                ? v.channel_language
                                                                : ""}
                                                            </td>
                                                            <td>
                                                              {v.channelDescription
                                                                ? v
                                                                  .channelDescription
                                                                  .length > 30
                                                                  ? v.channelDescription.substring(
                                                                    0,
                                                                    30
                                                                  ) + "..."
                                                                  : v.channelDescription
                                                                : ""}
                                                            </td>
                                                            <td>
                                                              {
                                                                v.PropertyType.find(obj => val._id === obj.PropertyId).AllChannelRule &&
                                                                  v.PropertyType.find(obj => val._id === obj.PropertyId).AllChannelRule.length > 0
                                                                  ? <span className="text-primary" onClick={() => { ruleUpdatefun(v, val) }}> View Rule</span>
                                                                  : <span className="text-primary" onClick={() => { ruleUpdatefun(v, val) }}>Select Rule</span>
                                                              }
                                                            </td>
                                                            <td onClick={(event) => {
                                                              toggleChannelStat(event)
                                                              setdataStats(v)
                                                            }}
                                                            >
                                                              Channel Statistics
                                                            </td>
                                                            <td>
                                                              <button
                                                                style={{
                                                                  transform:
                                                                    "scale(0.8)"
                                                                }}
                                                                className="btn btn-sm btn-danger"
                                                                onClick={(
                                                                  event
                                                                ) => {
                                                                  DeleteConfirmationDialog('Channel', 'Are you sure want to delete this channel?', v._id, val._id)
                                                                }}
                                                              >
                                                                <i className="trash icon me-0"></i>
                                                              </button>{" "}
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    }
                                                  )}
                                                </tbody>
                                              </Table>
                                            </div>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  } else return <div></div>;
                                })}
                              </tbody>
                            </Table>
                          </div>
                          <div
                            className="form-boxdiv"
                            style={{ marginTop: "15px" }}
                          >
                            <div className="form-boxtopline5">Channel Rule</div>
                            <div className="form-boxtopcont user-formAdmin">
                              <div
                                className="ag-theme-alpine"
                                style={{ height: "calc(50vh - 150px)" }}
                              >
                                <AgGridReact
                                  pagination={true}
                                  paginationPageSize={5}
                                  columnDefs={columns}
                                  defaultColDef={defaultColDef}
                                  enableBrowserTooltips={true}
                                  tooltipShowDelay={{ tooltipShowDelay: 0 }}
                                  rowData={props.allData.ruleData.filter(
                                    (obj) => {
                                      return obj.UserId === value._id;
                                    }
                                  )}
                                  gridOptions={gridOptions}
                                  gridReady={onGridReady}
                                  tooltipHideDelay={{ tooltipHideDelay: 100 }}
                                ></AgGridReact>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      <Modal
        isOpen={toggleUserDetail}
        toggle={() => settoggleUserDetail(!toggleUserDetail)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ borderRadius: "5px" }}
      >
        <ModalHeader
          toggle={() => settoggleUserDetail(!toggleUserDetail)}
          id="contained-modal-title-vcenter"
        >
          User Detail
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              padding: "15px",
              borderLeft: "8px solid #002c42cb",
              borderRadius: "10px",
              borderBottom: "1px solid gray",
              borderTop: "1px solid gray",
              borderRight: "1px solid gray",
            }}
          >
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label className="form-check-label font-weight-600">
                    User :{" "}
                  </label>
                  <span> {"cehjecdhj"}</span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label className="form-check-label font-weight-600">
                    Phone No.{" "}
                  </label>
                  <span> {"ghcdvcd"}</span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label className="form-check-label font-weight-600">
                    User Details :{" "}
                  </label>
                  <span
                    // onClick={() => setEmailToggle(!emailToggle)}
                    className="pointer link"
                  >
                    {"hjcj"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={show2}
        toggle={toggleChannelStat}
        size="xl"
        centered={true}
      >
        <ModalHeader className="model-title" size="xl" toggle={toggleChannelStat}>Channel Statistics</ModalHeader>
        <ModalBody className="model-content"  >
          <div className="ui main">
            {
              Object.keys(dataStats).length > 0 ? <ChannelStats e={dataStats} /> : <div></div>
            }
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={toggleChannelShow}
        toggle={toggleShowChannel}
        size="lg"
        centered={true}
      >
        <ModalHeader toggle={toggleShowChannel}>{onClickAddAndEditMsg}</ModalHeader>
        <ModalBody>
          <div className="ui main">
            <form className="ui form row">
              <div className="field">
                <label style={{ fontSize: "14px" }}>Property<i style={{ color: "red" }}>*</i></label>
                <Select
                  isMulti
                  name="Property"
                  options={array2}
                  defaultValue={propertyVal}
                  onChange={handlePropertySelect}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={selectedPropertyValues}
                />
                <p className="mt-1"><span className="font-weight-bold">Note:-</span> Property having less than 6 Channels can be selected </p>
              </div>

              <div className="field">
                <label style={{ fontSize: "14px" }}>Channel Name<i style={{ color: "red" }}>*</i></label>
                <input
                  type="text"
                  name="channelName"
                  placeholder="Channel Name"
                  maxLength={100}
                  onKeyDown={(e) => {
                    if (e.target.selectionStart === 0 && e.key === " ") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => onInputChange1(e)}
                  value={onClickData.channelName}
                />
              </div>
              <div className="field">
                <label style={{ fontSize: "14px" }}>Channel ID<i style={{ color: "red" }}>*</i></label>
                <input
                  type="text"
                  name="channelID"
                  placeholder="Channel ID"
                  onChange={(e) => {
                    if (e.target.value.match(/[^A-Za-z0-9]/)) {
                      return
                    }
                    onInputChange1(e)
                  }}
                  value={onClickData.channelID}
                />
              </div>
              <div className="field col-6" style={{ paddingRight: "3px" }}>
                <label>Channel Language</label>
                <select
                  className="form-control"
                  value={onClickData.channel_language}
                  name="channel_language"
                  onChange={(event) => handleC1(event)}
                >
                  <option value="">Select Language</option>
                  <option value="English">English</option>
                  <option value="Spanish">Spanish</option>
                  <option value="Portuguese">Portuguese</option>
                  <option value="French">French</option>
                  <option value="Dutch">Dutch</option>
                </select>
              </div>
              <div className="field col-6" style={{ paddingLeft: "3px" }}>
                <label>Channel Category</label>
                <select
                  className="form-control"
                  value={onClickData.channel_category}
                  name="channel_category"
                  onChange={(event) => handleC(event)}
                >
                  <option value="">Select Category</option>
                  {/* <option hidden={hide} value="Bulletin Board">Bulletin Board</option> */}
                  <option value="Bulletin Board">Bulletin Board</option>
                  <option value="Live">Live</option>
                  <option value="Security">Security</option>
                  <option value="VOD">VOD</option>
                  <option value="Schedules">Schedules</option>
                  <option value="Activities">Activities</option>
                </select>
              </div>
              <div className="field">
                <label style={{ fontSize: "14px" }}>Channel Description </label>
                <textarea
                  type="text"
                  name="channelDescription"
                  placeholder="Channel Description"
                  onChange={(e) => onInputChange1(e)}
                  value={onClickData.channelDescription}
                />
              </div>
              <div className="field col-6">
                <label style={{ fontSize: "14px" }}>Icon</label>

                <div class="input-group row">
                  <div classNmae="input-group-prepend"></div>
                  <div
                    className="custom-file col-8"
                    style={{ display: "flex", flexDirection: "column", gap: 4 }}
                  >
                    <input
                      type="file"
                      id="myfile"
                      name="myfile"
                      accept="image/*"
                      onChange={(e) => getFile(e)}
                    />
                    {/* <Button
                      className="form-control"
                      color="primary"
                      // onClick={handleOpenPickerLocalServer}
                      onClick={(e) => e.preventDefault()}
                    >
                      <div className="" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                        <div className="">RCC Cloud</div>
                      </div>
                    </Button> */}
                  </div>
                  <div
                    className="col-4"
                    style={{
                      height: 80,
                      width: 100,
                      margin: "0px 4px",
                      backgroundColor: "black",
                    }}
                  >
                    {onClickData?.programIcon != "" ? (
                      <img
                        src={onClickData?.programIcon}
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        alt="image"
                      />
                    ) : (
                      <img
                        src={iconImage}
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        alt="image"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="field col-6">
                {/* <label style={{ fontSize: "14px" }}>Video Source</label> */}
                <label style={{ fontSize: "14px" }}>Video Source<i style={{ color: "red" }}>*</i></label>

                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input radio-button"
                    id="1"
                    value="billboard"
                    name="videoSource"
                    onChange={(event) => ischecked(event)}
                    checked={
                      onClickData.videoSource &&
                        onClickData.videoSource[0] === "billboard"
                        ? true
                        : false
                    }

                  // disabled={save ? true : false}
                  />
                  <label className="form-check-label">Billboard</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input radio-button"
                    id="2"
                    value="encoder"
                    name="videoSource"
                    onChange={(e) => ischecked(e)}
                    checked={
                      onClickData.videoSource &&
                        onClickData.videoSource[0] === "encoder"
                        ? true
                        : false
                    }
                  />
                  <label className="form-check-label">Encoder</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    className="form-check-input radio-button"
                    id="3"
                    value="url"
                    name="videoSource"
                    onChange={(e) => ischecked(e)}
                    checked={
                      onClickData.videoSource &&
                        onClickData.videoSource[0] === "url"
                        ? true
                        : false
                    }
                  />
                  <label
                    className="form-check-label"
                    style={{ paddingBottom: "15px" }}
                  >
                    URL
                  </label>
                </div>
                {onClickData.videoSource &&
                  onClickData.videoSource[0] === "encoder" ? (
                  <div>
                    <input
                      type="text"
                      name="encoder"
                      value={onClickData.videoSource[1]}
                      placeholder="Encoder"
                      onChange={(event) => {
                        let ChannelData = { ...onClickData };
                        ChannelData.videoSource[1] = event.target.value;
                        setOnclickData(ChannelData);
                      }}
                    ></input>
                  </div>
                ) : (
                  " "
                )}
                {onClickData.videoSource &&
                  onClickData.videoSource[0] === "url" ? (
                  <div className="dropdown">
                    <input
                      type="text"
                      placeholder="Url"
                      name="url"
                      value={onClickData.videoSource[1]}
                      onChange={(event) => {
                        let ChannelData = { ...onClickData };
                        ChannelData.videoSource[1] = event.target.value;
                        setOnclickData(ChannelData);
                      }}
                    ></input>
                  </div>
                ) : (
                  " "
                )}
              </div>
              <div
                hidden={
                  onClickData.videoSource &&
                  onClickData.videoSource[0] == "encoder"
                  || onClickData.videoSource &&
                  onClickData.videoSource[0] == "url"
                }
                className="row"
                style={{ marginTop: "25px", marginBottom: "10px" }}
              >
                <div className="col-11 program-header">
                  <b>Billboards</b>
                </div>
                <div
                  className="col-1 text-right"
                  style={{
                    color: "#337ab7",
                    fontSize: "large",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                >
                  <span onClick={() => {
                    addbillboard();
                  }}>Add{" "}
                    <FontAwesomeIcon
                      className="icon"
                      icon={faPlusSquare}
                      style={{ paddingleft: "5px" }}
                    />
                  </span>
                </div>
                {/* <div></div> */}
                {onClickData &&
                  onClickData.billboard &&
                  onClickData.billboard.map((elem, i) => {
                    return (
                      // newFunction(handlebillboardstarttime, i, elem, handlebillboardendtime, handletimezoneChange, onClickData, timeZone, handlelayoutTypechange, handleChangeBillboard, array1, DeleteConfirmationDialog)
                      <div
                        className="row"
                        style={{ backgroundColor: "#f2f2f2", padding: "9px 5px" }}
                      >
                        <div className="col-2" style={{ padding: "2px", marginTop: "-8px" }}>
                          <label>
                            <b>Starts At</b>
                          </label>

                          {/* <input
                            type="time"
                            format="HH:mm"
                            name="ProgramSchedule"
                            onChange={(event) => handlebillboardstarttime(event.target.value, i)}
                            value={elem.startTime} /> */}
                          <TimePicker defaultValue={elem?.startTime} onValueChange={(value) => handlebillboardstarttime(value, i)} />
                          {/* <DatePicker
                            selected={
                              elem?.startTime
                                ? (() => {
                                  const [hours, minutes] = elem.startTime.split(":");
                                  const date = new Date();
                                  date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
                                  return date;
                                })()
                                : null
                            }
                            onChange={(time) => handlebillboardstarttime(time, i)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            filterTime={isAfterNow}
                            dateFormat="h:mm aa"
                            className="datepicker-input"
                          /> */}

                        </div>

                        <div className="col-2" style={{ padding: "2px", marginTop: "-8px" }}>
                          <label>
                            <b>Ends At</b>
                          </label>

                          {/* <input
                            type="time"
                            format="HH:mm"
                            name="ProgramSchedule"
                            onChange={(event) => handlebillboardendtime(event.target.value, i)}
                            value={elem.endTime} /> */}

                          <TimePicker defaultValue={elem?.endTime} onValueChange={(value) => handlebillboardendtime(value, i)} />

                          {/* <DatePicker
                            selected={
                              elem?.endTime
                                ? (() => {
                                  const [hours, minutes] = elem.endTime.split(":");
                                  const date = new Date();
                                  date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
                                  return date;
                                })()
                                : null
                            }
                            onChange={(time) => handlebillboardendtime(time, i)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            filterTime={isAfterNow}
                            dateFormat="h:mm aa"
                            className="datepicker-input"
                          /> */}
                        </div>

                        <div className="col-3" style={{ padding: "5px", marginTop: "-10px" }}>
                          <label>
                            <b>Timezone</b>
                          </label>
                          <select
                            onChange={(event) => {
                              handletimezoneChange(event.target.value, i, "Timezone");
                            }}
                            className="form-control"
                            value={onClickData.billboard[i].Timezone}
                          >
                            {timeZone.map(element => <option value={element.value}>{element.label}</option>
                            )}
                          </select>
                        </div>

                        <div className="col-4" style={{ padding: "5px", marginTop: "-10px" }}>
                          <b>Choose Layout </b>
                          <input name={"layout" + i} type="radio" value="layout" id={"layout" + i} className="radio-button"
                            onChange={(event) => {
                              handlelayoutTypechange(event.target.value, i, "layoutType", "layout");
                            }}
                            checked={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType == "layout" ? true : false : false} />
                          <b style={{ paddingLeft: "15px" }}>Input Url </b>
                          <input name={"url" + i} type="radio" id={"url" + i} value="url" className="radio-button"
                            onChange={(event) => {
                              handlelayoutTypechange(event.target.value, i, "layoutType", "url");
                            }}
                            checked={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType == "url" ? true : false : false} />
                          <select
                            onChange={(event) => {
                              handleChangeBillboard(event.target, i, "billboard", "billboard_name");
                            }}
                            className="form-control"
                            value={`${elem.billboard_name} (${elem.billboard})`}
                            hidden={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType != "layout" : true}
                          >
                            <option value="">Choose Layout</option>
                            {array1.map((optelem) => {
                              return (
                                <option value={optelem.value}>{optelem.label}</option>
                              );
                            })}
                          </select>
                          <input
                            type="text"
                            placeholder="Layout Url"
                            name="url"
                            value={onClickData.billboard[i] && onClickData.billboard[i].billboard ? onClickData.billboard[i].billboard : ""}
                            hidden={onClickData.billboard[i] && onClickData.billboard[i].layoutType ? onClickData.billboard[i].layoutType != "url" : true}
                            onChange={(event) => {
                              handletimezoneChange(event.target.value.trim(), i, "billboard");
                            }}
                          ></input>
                        </div>

                        <div className="col text-center d-flex align-items-center" style={{ marginTop: "6px", marginLeft: "7px" }}>
                          <label>
                            <b></b>
                          </label>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(event) => {
                              event.preventDefault();
                              // Deletebillboarddata(i)
                              DeleteConfirmationDialog("billboard", "Are you sure want to delete this billboard?", event, i);

                            }}
                          >
                            <i className="trash icon me-0"></i>
                          </button>{" "}
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div
                hidden={
                  onClickData.videoSource &&
                  onClickData.videoSource[0] === "billboard"
                }
                className="row" style={{ marginTop: "25px", marginBottom: "10px" }}>
                <div className="col-11 program-header">
                  <b>Programs</b>
                </div>
                <div className="col-1 text-right"
                  style={{
                    color: "#337ab7",
                    fontSize: "large",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                >
                  <span onClick={() => { addprogram(); }}>
                    Add{" "}
                    <FontAwesomeIcon
                      className="icon"
                      icon={faPlusSquare}
                      style={{ paddingleft: "5px" }}
                    />
                  </span>

                </div>

                {onClickData &&
                  onClickData.program &&
                  onClickData.program.map((elem, i) => {
                    return (
                      <div
                        className="row"
                        style={{ backgroundColor: "#f2f2f2", padding: "15px" }}>
                        <div className="col-4" style={{ padding: "5px" }}>
                          <label>
                            <b>Title</b>
                          </label>
                          <input
                            name={`title_${i}`}
                            className="form-control"
                            placeholder="Title of Program"
                            onChange={(event) =>
                              handleChangeProgram(event.target.value, i, "title")
                            }
                            value={elem.title}
                          />
                        </div>

                        <div className="col-4" style={{ padding: "5px" }}>
                          <label>
                            <b>Language</b>
                          </label>
                          <select
                            className="form-control"
                            value={elem.language}
                            name={`programLanguage_${i}`}
                            onChange={(event) =>
                              handleChangeProgram(
                                event.target.value,
                                i,
                                "language"
                              )
                            }
                          >
                            <option value="">Select Language</option>
                            <option value="English">English</option>
                            <option value="Spanish">Spanish</option>
                            <option value="Portuguese">Portuguese</option>
                            <option value="French">French</option>
                            <option value="Dutch">Dutch</option>
                          </select>
                        </div>

                        <div className="col-4" style={{ padding: "5px" }}>
                          <label>
                            <b>Duration</b>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name={`duration_${i}`}
                            placeholder="Duration"
                            value={elem.duration}
                            readOnly
                          />
                        </div>

                        <div className="col-2" style={{ padding: "5px" }}>
                          <label>
                            <b>Starts At</b>
                          </label>
                          <input
                            type="time"
                            format="HH:mm"
                            name="ProgramSchedule"
                            onChange={(event) =>
                              handleStartTime(event.target.value, i)
                            }
                            value={elem.startTime}
                          />
                        </div>

                        <div className="col-2" style={{ padding: "5px" }}>
                          <label>
                            <b>Ends At</b>
                          </label>
                          <input
                            type="time"
                            format="HH:mm"
                            name="ProgramSchedule"
                            onChange={(event) =>
                              handleEndTime(event.target.value, i)
                            }
                            value={elem.endTime}
                          />
                        </div>

                        <div className="col-8" style={{ padding: "5px" }}>
                          <label>
                            <b>Description</b>
                          </label>
                          <input
                            name={`programDescription_${i}`}
                            placeholder="Description"
                            onChange={(event) =>
                              handleChangeProgram(
                                event.target.value,
                                i,
                                "description"
                              )
                            }
                            value={elem.description}
                          />
                        </div>
                        {/* <div className="col-1" style={{ padding: "5px" }}> */}
                        <div className="col-1 text-right">
                          <FontAwesomeIcon
                            className="icon"
                            icon={faTimesCircle}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              cursor: "pointer",
                            }}
                            // style={{ paddingLeft: "5px" }}
                            onClick={() => removeProgram(i)}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Button
                  color="success"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    if (save) {
                      saveProgram();
                      setSelectedRuleValues([]);
                      setPropertyVal([]);
                      setSelectedPropertyValues([])
                    } else {
                      UpdateChannelinfo();
                      setSelectedRuleValues([]);
                      setPropertyVal([]);
                      setSelectedPropertyValues([])
                    }
                  }}
                >
                  {save ? "Save" : "Update"}
                </Button>
                <Button
                  color="danger"
                  onClick={() => {
                    setSelectedPropertyValues([])
                    settoggleChannelShow(false);
                  }}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={propertyeditmodal}
        toggle={togglepropertyedit}
        // size="sm"
        centered={true}
      >
        <ModalHeader toggle={togglepropertyedit}>{onClickAddAndEditMsg}</ModalHeader>
        <ModalBody>
          <div className="ui main">
            <form className="ui form">
              <div className="field">
                <label>Name<i style={{ color: "red" }} >*</i></label>
                <input
                  type="text"
                  name="Name"
                  placeholder="Name"
                  onKeyDown={(e) => {
                    if (e.target.selectionStart === 0 && e.key === " ") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => onInputChange3(e)}

                  value={onClickProperty.Name}
                  required
                />
              </div>
              <div className="field">
                <label>Address1</label>
                <input
                  type="text"
                  name="Address1"
                  placeholder="Address1"
                  onKeyDown={(e) => {
                    if (e.target.selectionStart === 0 && e.key === " ") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => onInputChange3(e)}
                  value={onClickProperty.Address1}
                />
              </div>
              <div className="field">
                <label>Address2</label>
                <input
                  type="text"
                  name="Address2"
                  placeholder="Address2"
                  onKeyDown={(e) => {
                    if (e.target.selectionStart === 0 && e.key === " ") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => onInputChange3(e)}
                  value={onClickProperty.Address2}
                />
              </div>
              <div className="row">
                <div className="field col-6" style={{ paddingRight: "3px" }}>
                  <label>Country</label>
                  <input
                    type="text"
                    name="Country"
                    placeholder="Country"
                    onKeyDown={(e) => {
                      inputValidation(e);
                    }}
                    onChange={(e) => onInputChange3(e)}
                    value={onClickProperty.Country}
                  />
                </div>
                <div className="field col-6" style={{ paddingLeft: "3px" }}>
                  <label>State</label>
                  <input
                    type="text"
                    name="State"
                    placeholder="State"
                    onKeyDown={(e) => {
                      inputValidation(e);
                    }}
                    onChange={(e) => onInputChange3(e)}
                    value={onClickProperty.State}
                  />
                </div>
                <div className="field col-6" style={{ paddingRight: "3px" }}>
                  <label>City</label>
                  <input
                    type="text"
                    name="City"
                    placeholder="City"
                    onKeyDown={(e) => {
                      inputValidation(e);
                    }}
                    onChange={(e) => onInputChange3(e)}
                    value={onClickProperty.City}
                  />
                </div>
                <div className="field col-6" style={{ paddingLeft: "3px" }}>
                  <label>Zip</label>
                  <input
                    type="text"
                    name="Zip"
                    placeholder="Zip"
                    onKeyDown={(e) => {
                      const key = e.keyCode || e.charCode;
                      if (
                        (key >= 48 && key <= 57) ||  // Allow numeric digits
                        key === 8 || key === 9 ||    // Allow backspace and tab
                        key === 37 || key === 39     // Allow left and right arrow keys
                      ) {
                        return;
                      }
                      e.preventDefault();
                    }}

                    onChange={(e) => { onInputChange3(e); }}
                    value={onClickProperty.Zip}
                  />
                </div>
              </div>
              <div className="field">
                <label>Phone Number <i style={{ color: "red" }} >*</i></label>
                <input
                  type="text"
                  name="PhoneNumber"
                  placeholder="Phone Number"
                  onChange={(e) => {
                    if (
                      e.target.value.match(/[^0-9]/) === null &&
                      e.target.value.length <= 10
                    ) {
                      onInputChange3(e)
                    }
                  }}
                  value={onClickProperty.PhoneNumber}
                />
              </div>
              <div className="field">
                <label>Email</label>
                <input
                  type="text"
                  name="Email"
                  placeholder="Email"
                  onChange={(e) => onInputChange3(e)}
                  value={onClickProperty.Email}
                />
              </div>
              <div className="field">
                <label>Contact Name</label>
                <input
                  type="text"
                  name="ContactName"
                  placeholder="Contact Name"
                  onKeyDown={(e) => {
                    inputValidation(e);
                  }}
                  onChange={(e) => onInputChange3(e)}
                  value={onClickProperty.ContactName}
                />
              </div>
              <div className="text-end col-12">
                <Button
                  color="success"
                  style={{ marginRight: "5px" }}
                  onClick={() => {
                    // UpdateChannelrule();
                    if (save3) {
                      SaveProperty();
                    } else {
                      Updateproperty();
                    }
                  }}
                >
                  {save3 ? "Save" : "Update"}
                </Button>
                <Button
                  color="danger"
                  onClick={() => {
                    togglepropertyedit();
                    setOnclickProperty({});

                  }}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={ruleEditmodal}
        toggle={toggleRuleEdit}
        // size="sm"
        centered={true}
      >
        <ModalHeader className="align-items-normal" toggle={toggleRuleEdit}>{onClickAddAndEditMsg}
          <div class="row">
            <div className="col-12 model-note">  Note: Only applicable two factor combinations are:</div>
          </div>

          <div class="row">
            <div class="col-4 model-note"><span className="model-note-icon">1</span>. Account+GEO</div>
            <div class="col-4 model-note text-center"><span className="model-note-icon">2</span>. IP+GEO </div>
            <div class="col-4 model-note"><span className="model-note-icon">3</span>. MAC+GEO</div>
          </div>

        </ModalHeader>
        <ModalBody>
          <div className="ui main">
            <form className="ui form">
              <div className="field">
                <label>Channel Rules Name<i style={{ color: "red" }}>*</i></label>
                <input
                  type="text"
                  name="ChannelRulesName"
                  placeholder="Channel Rules Name "
                  onChange={(e) => onInputRuleChange(e)}
                  value={onClickRuleData.ChannelRulesName}
                />
              </div>

              <div className="field" style={{ padding: "10px", border: "1px solid #53535369" }}>
                <label>Rule Type<i style={{ color: "red" }}>*</i></label>
                <Select
                  isMulti
                  name="colors"
                  options={ruleSelectValues}
                  value={defaultVal}
                  onChange={handleRuleSelect}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
                {onClickRuleData.RuleType && selectedRuleValues.length > 0
                  ? selectedRuleValues.map((elm, index) => {
                    return (
                      <>
                        {" "}
                        {
                          elm.value != "Deviation" && elm.value != "Geo_Location_Original" ? <div>
                            <label style={{ marginRight: "3px", fontWeight: "bold" }}>
                              {elm.value === "Geo_Location" ? "Geo Location" : elm.label}
                            </label>
                            {elm.value === "Geo_Location" && <span className="text-secondary">{elm.value == "Geo_Location" && "i.e please enter <Lat><space><Long>"}</span>}
                            {elm.value === "IpAddress" && <span className="text-secondary ml-2"> {ipAddressNote}</span>}
                            {elm.value === "IpAddress" ?
                              <div className="row">
                                <div className="col-4">
                                  <select
                                    className="form-control"
                                    name="IpFormat"
                                    onChange={(event) => IPformatFun(event)}
                                    value={IPFormatV ? IPFormatV : ""}
                                  >
                                    <option hidden>Select IP Format</option>
                                    <option value="SingleIpAddress">Single IP address</option>
                                    <option value="IpAddressRange"> IP address range</option>
                                    <option value="CIDR">CIDR</option>
                                  </select>
                                </div>

                                {onClickRuleData.RuleType && onClickRuleData.RuleType.IpAddress ?
                                  <div className="col-8">
                                    <input
                                      type="text"
                                      className=""
                                      style={{ marginLeft: "5px", paddingRight: "5px" }}
                                      // placeholder={IPFormatV}
                                      onChange={(event) => {
                                        // if (!event.target.value.match(/[^0-9.:-]/)) {
                                        setIPvalue(event, IPFormatV);
                                        // }
                                      }}
                                      placeholder={ipAddressPlaceHolder}
                                      value={IPFormatVal ? IPFormatVal : ""}
                                    ></input>
                                  </div> : ""
                                }
                              </div>
                              : <input
                                type="text"
                                style={{ marginTop: "3px" }}
                                name={elm.value}
                                value={
                                  onClickRuleData.RuleType[elm.value]
                                    ? onClickRuleData.RuleType[elm.value]
                                    : ''
                                }
                                placeholder={elm.label}
                                onChange={(event) => {
                                  // if (!event.target.value.match(/[^0-9.:-]/)) {
                                  handlec2(event);
                                  // }
                                }}
                                readOnly={elm.value === "AccountNumber" ? true : false}
                              ></input>}
                          </div> : ""
                        }

                        {elm.value === "Geo_Location" ? <div>
                          <label
                            style={{ marginRight: "3px", fontWeight: "bold" }}
                          >
                            Deviation (in mins)
                          </label>
                          <input
                            type="text"
                            style={{ marginTop: "3px", marginBottom: "5px" }}
                            name="Deviation"
                            value={
                              onClickRuleData.RuleType
                                ? onClickRuleData.RuleType["Deviation"] ? onClickRuleData.RuleType["Deviation"] : ""
                                : ""
                            }
                            placeholder={"Deviation"}
                            onChange={(event) => {
                              handlec2(event);
                            }}
                            readOnly={elm.value === "AccountNumber" ? true : false}
                          ></input>
                        </div> : ""
                        }
                      </>
                    );
                  })
                  : ""}
              </div>
            </form>
          </div>
          <div className="text-end col-12">
            <Button
              color="success"
              style={{ marginRight: "5px" }}
              // onClick={() => {
              //   UpdateChannelrule();
              // }}
              onClick={() => {
                if (save1) {
                  saveChannelRule();
                }
                else { UpdateChannelrule(); }
              }}
            >
              {save1 ? "Save" : "Update"}
            </Button>
            <Button
              color="danger"
              onClick={() => {
                toggleRuleEdit();
                setSelectedRuleValues([]);
                setDefaultVal([]);
                setIPFormatV([]);
                props.getAllPropertyData();
                setIPFormatVal([]);
              }}
            >
              Cancel
            </Button>
          </div>

        </ModalBody>
      </Modal>
      <Modal
        isOpen={ruleEditRulemodal}
        toggle={toggleRuleEditModal}
        // size="sm"
        centered={true}
      >
        <ModalHeader toggle={toggleRuleEditModal}>{onClickDelete ? "Edit Rule" : "Select Rule"}</ModalHeader>
        <ModalBody>

          <div className="ui main">
            <form className="ui form">
              <div className="field">
                <label>Select Channel Rule</label>

                <Select
                  isMulti
                  name="Rule Name"
                  options={array3}
                  placeholder="Choose Rule"
                  defaultValue={ruleSelectedValue}
                  onChange={(event) => { handleselectedR(event) }}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
            </form>
          </div>
          <div className="text-end col-12">
            <Button
              color="success"
              style={{ marginRight: "5px" }}

              onClick={(e) => {
                UpdateChannelruleForChannel(e);
                setchannelRuleName('');
              }}
            >
              {onClickDelete ? "Update" : "Save"}

            </Button>
            <Button
              color="danger"
              onClick={() => {
                toggleRuleEditModal();
                setchannelRuleName('');
              }}
            >
              Cancel
            </Button>
          </div>

        </ModalBody>
      </Modal>
      <Modal size="md" isOpen={modaleditLayoutPropPass} toggle={() => toggleeditLayoutPropPass("")}>
        <ModalHeader toggle={() => toggleeditLayoutPropPass("")}>Replicate Layout</ModalHeader>
        <ModalBody>
          <div>
            <label style={{ marginTop: "0px" }}>
              <b>Enter the Replicated Layout Name </b>
              <b style={{ color: "red" }}>*</b>
            </label>
            <input
              style={{ marginTop: "10px" }}
              className="form-control"
              placeholder="Layout Name"
              value={layoutLocalReplicate}
              onChange={(e) => {
                setlayoutLocalReplicate(e.target.value);
              }}
            ></input>
            <select
              className="form-control mt-3"
              value={replicateUser}
              name='replicateUser'
              onChange={(e) => {
                setReplicateUser(e.target.value)
                console.log(e.target.value)
              }}
            >
              <option value=''>Select User</option>
              {props.allData.users && props.allData.users.map((e) =>
                e.type !== 'admin' && <option value={e._id}>{e.customerId}</option>
              )}
            </select>
            {replicateUser && <select
              className="form-control mt-3"
              value={replicateProperty}
              name='replicateProperty'
              onChange={(e) => {
                setReplicateProperty(e.target.value)
              }}
            >
              <option value=''>Select Property</option>
              {props.allData.property && props.allData.property.map((e) =>
                e.UserId === replicateUser && <option value={e._id}>{e.Name}</option>
              )}
            </select>}
            <div className="row">
              <Button
                color="primary"
                onClick={() => ProceedToThisLayoutReplicate()}
                className="ButtonProceed"
              >
                Proceed
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <NasPop
        showPicker={showPicker}
        files={files}
        selectedFiles={selectedFiles}
        handleSelectFile={handleSelectFile}
        handleNASSubmit={handleLocalSubmit}
        setShowPicker={setShowPicker}
      />
    </div>
  );
};

export default AdminDashboard;

